export default __webpack_public_path__ + "static/media/tick.d5f3c8da.png";